import {TodayCardKind, TodayPromoKind} from '@/ts/types/component/today-page';

// i18n key maps for the Today page (IPD-2903 epic). Kept apart from the generic session /
// homework strings on purpose: the Today copy sheet is its own deliverable (IPD-2982), and a
// wording change there must not reach the intervention screens that share the same nouns.

/**
 * Kind label shown above an item's title when it has no parent programme.
 *
 * The German values match the terms the app already uses elsewhere ("Sitzung", "Hausaufgabe",
 * "Fragebogen"). The Figma German sheets label the same category ASSESSMENT in one variant and
 * FRAGEBOGEN in another — one label per kind and language, and this is the one.
 */
export const todayCardKindLabelKey: Record<TodayCardKind, string> = {
  [TodayCardKind.session]: 'today_card_kind_session',
  [TodayCardKind.homework]: 'today_card_kind_homework',
  [TodayCardKind.challenge]: 'today_card_kind_challenge',
  [TodayCardKind.assessment]: 'today_card_kind_assessment',
  [TodayCardKind.program]: 'today_card_kind_program',
  [TodayCardKind.content]: 'today_card_kind_content',
};

/**
 * Stand-in icon per kind, shown inside the tinted circle when the item has no image of its
 * own. Design has bespoke illustrations for these in the prototype but has not handed over the
 * assets, so the material glyphs are the interim (IPD-2904).
 */
export const todayCardKindIcon: Record<TodayCardKind, string> = {
  [TodayCardKind.session]: 'play_arrow',
  [TodayCardKind.homework]: 'edit_note',
  [TodayCardKind.challenge]: 'flag',
  [TodayCardKind.assessment]: 'fact_check',
  [TodayCardKind.program]: 'spa',
  [TodayCardKind.content]: 'article',
};

/**
 * Heading of each discovery promo (IPD-2977). The three are fixed copy rather than CMS content;
 * only the choice of which one shows on a given day comes from the backend.
 */
export const todayPromoTitleKey: Record<TodayPromoKind, string> = {
  [TodayPromoKind.challenge]: 'today_tasks_promo_challenge_title',
  [TodayPromoKind.medicalProgram]: 'today_tasks_promo_medical_title',
  [TodayPromoKind.preventionProgram]: 'today_tasks_promo_prevention_title',
};

/** Supporting line under each promo heading, one per {@link todayPromoTitleKey} entry. */
export const todayPromoBodyKey: Record<TodayPromoKind, string> = {
  [TodayPromoKind.challenge]: 'today_tasks_promo_challenge_body',
  [TodayPromoKind.medicalProgram]: 'today_tasks_promo_medical_body',
  [TodayPromoKind.preventionProgram]: 'today_tasks_promo_prevention_body',
};
